import { Base } from '@studiometa/js-toolkit';
import { nextTick } from '@studiometa/js-toolkit/utils';
import { Frame } from '@studiometa/ui';

/**
 * Header component
 */
export default class Blog extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Blog',
    components: {
      Frame,
    },
    refs: ['loadmore', 'container', 'items[]'],
  };

  /**
   * Click on loadmore
   * @param {object} props Props
   * @param {object} props.target current element
   * @returns {void}
   */
  onLoadmoreClick({ target }) {
    const url = target.dataset.href;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const results = html.querySelector(`[data-ref="Blog.container"]`);

        this.hideNewItems(results);

        nextTick(() => {
          this.$refs.container.innerHTML += results.innerHTML;
        });

        const newLoadmore = html.querySelector(`[data-ref="Blog.loadmore"]`);
        if (newLoadmore) {
          this.$refs.loadmore.dataset.href = newLoadmore.dataset.href;
        } else {
          this.$refs.loadmore.style.display = 'none';
        }

        this.$update();

        nextTick(() => {
          setTimeout(() => {
            this.showNewItems();
          }, 200);
        });
      });
  }

  /**
   * [hideNewProducts description]
   * @param  {object} results element.
   * @returns {void}
   */
  hideNewItems(results) {
    results.querySelectorAll('[data-ref="Blog.items[]"]').forEach((element) => {
      element.classList.add('transition', 'duration-300', 'opacity-0', 'blur-sm');
    });
  }

  /**
   * Change class to new products to display them
   * @returns {void}
   */
  showNewItems() {
    this.$refs.items.forEach((element) => {
      element.classList.remove('opacity-0', 'blur-sm');
    });
  }
}
